import React, { Component } from "react";
import Week from "../../../components/Week/Week";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : LicensesForm
Description : Compoente que alberga el formulario de Licenses definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class WeekForm extends Component {
    render() {
        return (
            <Week />
        )
    }
}

export default WeekForm;